import React, { useState, useEffect, useContext, useRef } from 'react';

// Context

//Styles 
import newStyle from "./NewDashboardCategoriesManager.module.css";
import Dstyles from "../DashboardFileManagement/DashboardFileManagement.module.css"
import 'react-toastify/dist/ReactToastify.css';
// import userStyles from "../../../UserDashboard/UserAddNewFile/UserAddNewFile.module.css"

// Re Useable Components
import DashboardSideMenu from '../DashboardReuseAbleComponents/DashboardSideMenu';
import ShowProfileModal from '../DashboardFileManagement/CardDetail/ShowProfileModal';
import EditCategoryModal from '../DashboardAddNewFile/EditCategory/EditCategoryModal';
import DashboardHeader from '../DashboardReuseAbleComponents/DashboardHeader';

//Images
import arrowIcon from "../../../assets/img/DashboardICons/ArrowRounded.svg"
import axios from 'axios';
import { UserContext } from '../../Context/UserContextProvider';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { Editor } from '@tinymce/tinymce-react';
import { Helmet } from 'react-helmet';


const LandingManagement = (props) => {
    let history = useHistory();

    let [isModelOpen, setIsModelOpen] = useState(false);

    let [editingTitle, setEditingTitle] = useState("");
    let [editingDescription, setEditingDescription] = useState("");
    let [editingLink, setEditingLink] = useState("");
    let [editingId, setEditingId] = useState(0);

    let editorRef = useRef();

    const { userToken, permissions } = useContext(UserContext)
    const [showPage, setShowPage] = useState({
        pageNumber: 1,
        categoriID: "",
        categoriTitle: "",
        subCategoryID: "",
        selectedSub: "",
        subIsSelected: false
    })
    const [modalShow, setModalShow] = useState(false);
    const [editModalShow, setEditModalShow] = useState(false);
    const [isLoading, setIsLoading] = useState(true)
    const [userpermissions, setUserpermissions] = useState({
        isSuperUser: "",
        isConsultant: ""
    });

    let [filesToAdd, setFilesToAdd] = useState([]);
    let [filesToAddTitle, setFilesToAddTitle] = useState([]);

    let [landings, setLandings] = useState([]);


    useEffect(() => {
        axios.get("Landing").then((res) => {
            setLandings(res.data);
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        sessionStorage.removeItem("searchData");
        sessionStorage.removeItem("pageData");
        sessionStorage.removeItem("categories");
        sessionStorage.removeItem("subCategory");
        sessionStorage.removeItem("mainCategory");
        sessionStorage.removeItem("dealType");
        sessionStorage.removeItem("filters");
    }, []);

    useEffect(() => {
        if (permissions) {
            const isSuperUser = permissions.find((item => item === 0))
            const isConsultant = permissions.find((item => item === 11))
            setUserpermissions((prev) => {
                return { ...prev, isSuperUser: isSuperUser, isConsultant: isConsultant };
            });
        }

    }, [permissions]);

    function goBackToDashboard(){
        history.push("/DashboardMain");
    }

    function addNewFile(id, title){
        if (editingId != 0){
            axios.put("Landing/AddEstateLandings", {
                estateId: id,
                landings: editingId
            }, {
                headers: {
                    authorization: "Bearer " + userToken
                }
            });
        }

        setFilesToAdd((prev) => {
            return [...prev, id];
        });
        setFilesToAddTitle((prev) => {
            return [...prev, title];
        });
    }

    function startEditing(id){
        axios.get(`Estate/Landing?id=${id}`).then((res) => {
            let files = res?.data?.data?.data;

            let cacheId = [];
            let cacheTitle = [];

            files.forEach((file) => {
                cacheId.push(file.id);
                cacheTitle.push(file.title);
            });

            setFilesToAdd(cacheId);
            setFilesToAddTitle(cacheTitle);
            setIsEditing(id); 
        });
    }

    function removeFile(id){
        if (editingId != 0){
            axios.put("Landing/RemoveEstateLandings", {
                estateId: id,
                landings: editingId
            }, {
                headers: {
                    authorization: "Bearer " + userToken
                }
            });
        }

        let cacheFiles = [];
        let cacheFileTitles = [];

        filesToAdd.forEach((file, index) => {
            if (file == id){
                return;
            }

            cacheFiles.push(file);
            cacheFileTitles.push(filesToAddTitle[index]);
        })

        setFilesToAdd(cacheFiles);
        setFilesToAddTitle(cacheFileTitles);
    }

    function submitHandle(){
        if (editingId == 0){
            setIsLoading(true);
            axios.post("Landing", {
                title: editingTitle,
                description: editingDescription,
                link: editingLink
            }, {
                headers: {
                    authorization: "Bearer " + userToken
                }
            }).then((res) => {
                if (filesToAdd.length > 0){
                    axios.get("Landing").then((res) => {
                        let id = res.data[res.data.length - 1].id;

                        let addingFiles = [];
                        filesToAdd.forEach((file) => {
                            addingFiles.push(axios.put("Landing/AddEstateLandings", {
                                estateId: file,
                                landings: id
                            }, {
                                headers: {
                                    authorization: "Bearer " + userToken
                                }
                            }));
                        });

                        Promise.all(addingFiles).then(() => {
                            window.location.reload();
                        })
                    });
                }else{
                    window.location.reload();
                }
                
            });
        }else{
            setIsLoading(true);
            axios.put("Landing", {
                title: editingTitle,
                description: editingDescription,
                link: editingLink,
                id: editingId
            }, {
                headers: {
                    authorization: "Bearer " + userToken
                }
            }).then((res) => {
                window.location.reload();
            });
        }
    }

    let [searchTask, setSearchTask] = useState(null);
    let [searchFiles, setSearchFiles] = useState([]);
    let [searchQuery, setSearchQuery] = useState("");

    function searchName(){
        if (searchQuery == "" || searchQuery == null || searchQuery == undefined){
            searchFiles([]);
            clearTimeout(searchTask);
            return;
        }

        if (searchTask != null){
            clearTimeout(searchTask);
        }

        setSearchTask(setTimeout(() => {
            axios.get(`Estate?PageId=1&Search=${searchQuery}&Take=6&OrderBy=2&Status=7`).then((res) => {
                setSearchFiles(res?.data?.data?.data || []);
            });
        }, 1000));
    }

    function setIsEditing(id){
        if (id == 0){
            setEditingId(0);
            setEditingTitle("");
            setEditingDescription("");
            setEditingLink("");
            return;
        }
        setEditingId(id);
        setEditingTitle(landings.find((l) => l.id == id).title);
        setEditingDescription(landings.find((l) => l.id == id).description);
        setEditingLink(landings.find((l) => l.id == id).link);
        setIsModelOpen(true);
    }

    function deleteLanding(id){
        axios.delete(`Landing?id=${id}`, {
            headers: {
                authorization: "Bearer " + userToken
            }
        }).then((res) => {
            window.location.reload();
        });
    }

    return (
        <>
        <Helmet>
            <style>
                {`
                    .tox-tinymce-aux{z-index:99999999999 !important;}
                    .tox {
                      z-index: 9999999 !important;
                    }
                `}
            </style>
        </Helmet>
            <style type="text/css">
                {`
                    .dropdown-toggle {
                        width: 170px;
                        height: 44px;
                        background: #f9f9f9;
                        border: 1px solid #e2e2e2;
                        border-radius: 34px;
                        margin-left: 0.75rem;
                        color: #1D1D1D;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    .dropdown-toggle:after,
                    .btn-success:after {
                        content: none;
                    }
                    
                    .btn-success {
                        background: #f9f9f9 !important;
                        border: 1px solid #e2e2e2 !important;
                        color: #1D1D1D !important;
                        box-shadow: none !important;
                    }
                
                    .dropdown-menu {
                        width: 170px;
                        background: #F9F9F9;
                        border: 1px solid #E1E1E1;
                        border-radius: 34px;
                    }

                    .dropdown-toggle:hover {
                        background: #f4f4f4;
                        color: #1D1D1D;
                        border-color: #e5e5e5;
                        border: 1px solid #e2e2e2;
                    }
                
                    .dropdown-item {
                        margin: .5rem 0;
                        padding: .5rem .5rem .5rem 0;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
                
                    .dropdown-item:hover {
                        background: #E7EAF4 !important;
                        border-radius: 24px !important;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
    `}
            </style>

            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />


            {isLoading ? (
                <div className={Dstyles.loader_container}>
                    <div className={Dstyles.spinner}></div>
                </div>
            )
                : (
                    <div className='container-fluid'>
                        <div className={`${newStyle.popup_container}`} hidden={!isModelOpen}>
                            <div className={`${newStyle.popup_container_content}`}>
                                <div className={`${newStyle.popup_container_content_header}`}>
                                    <div className={`${newStyle.popup_container_content_header_title}`}>
                                        <div className={`${newStyle.popup_container_content_header_title_content}`}>ویرایش لندینگ</div>
                                    </div>
                                    <div className={`${newStyle.popup_container_content_header_title_content}`} onClick={() => {setIsModelOpen(false); setIsEditing(0)}}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style={{width: "20px", height: "20px"}}><path d="M378.4 71.4c8.5-10.1 7.2-25.3-2.9-33.8s-25.3-7.2-33.8 2.9L192 218.7 42.4 40.6C33.9 30.4 18.7 29.1 8.6 37.6S-2.9 61.3 5.6 71.4L160.7 256 5.6 440.6c-8.5 10.2-7.2 25.3 2.9 33.8s25.3 7.2 33.8-2.9L192 293.3 341.6 471.4c8.5 10.1 23.7 11.5 33.8 2.9s11.5-23.7 2.9-33.8L223.3 256l155-184.6z"/></svg></div>
                                </div>
                                <div className={`${newStyle.popup_container_content_body}`}>
                                    <div className={`${newStyle.popup_container_content_body_label}`}>
                                        نام لندینگ را وارد کنید
                                    </div>
                                    <div className={`${newStyle.popup_container_content_body_input}`}>
                                        <input placeholder='نام لندینگ...' style={{border: "none"}} value={editingTitle} onChange={(ev) => {setEditingTitle(ev.target.value)}}></input>
                                    </div>
                                    <div className={`${newStyle.popup_container_content_body_label}`}>
                                        توضیحات لندینگ را وارد کنید
                                    </div>
                                    <div className={`${newStyle.popup_container_content_body_text}`}>
                                    <Editor
                                        tinymceScriptSrc={`${process.env.PUBLIC_URL}/assets/tinymce/tinymce.min.js`}
                                        onInit={(evt, editor) => editorRef.current = editor}
                                        value={editingDescription}
                                        init={{
                                            height: 350,
                                            width: "100%",
                                            menubar: true,
                                            resize: false,
                                            directionality: "rtl",
                                            plugins: [
                                                'advlist', 'autolink', 'lists', 'link', 'anchor', 'code', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'fullscreen', 'insertdatetime', 'table', 'help', 'wordcount'
                                            ],
                                            toolbar: 'undo redo | casechange blocks | bold italic backcolor | ' +
                                                'alignleft aligncenter alignright alignjustify | ' +
                                                'bullist numlist checklist outdent indent | removeformat | a11ycheck code table help',
                                            content_style: 'body { font-family:Vazir,Arial,sans-serif; font-size:14px, direction:rtl }'
                                        }}
                                        onEditorChange={(con, editor) => setEditingDescription(con)}
                                    />
                                    </div>
                                    <div className={`${newStyle.popup_container_content_body_label}`}>
                                        لینک لندینگ را وارد کنید
                                    </div>
                                    <div className={`${newStyle.popup_container_content_body_input}`}>
                                        <input placeholder='لینک لندینگ...' style={{border: "none"}} value={editingLink} onChange={(ev) => {setEditingLink(ev.target.value.replace(" ", "-"))}}></input>
                                    </div>
                                    <div className={`${newStyle.popup_container_content_body_label}`}>
                                        فایل های لندینگ
                                    </div>
                                    <div className={`${newStyle.popup_container_content_body_input}`}>
                                        {
                                            searchFiles.length > 0? <div className={`${newStyle.popup_search_dropdown}`}>
                                                                        {
                                                                            searchFiles.map((files) => {
                                                                                if (filesToAddTitle.includes(files.title)){
                                                                                    return <></>
                                                                                }
                                                                                return <div className={`${newStyle.popup_search_dropdown_item}`} onClick={() => {addNewFile(files.id, files.title); setSearchQuery(""); setSearchFiles([])}}>
                                                                                    {files.title}
                                                                                </div>
                                                                            })
                                                                        }
                                                                </div> : <></>
                                        }
                                        
                                        <input placeholder='فایل های لندینگ' style={{border: "none"}} value={searchQuery} onChange={(ev) => {setSearchQuery(ev.target.value); searchName()}}></input>
                                    </div>
                                    <div className={`${newStyle.popup_files_list}`}>
                                        {
                                            filesToAdd.map((file, index) => {
                                                return  <div className={`${newStyle.popup_files_item}`} onClick={() => {removeFile(file)}}>
                                                            {filesToAddTitle[index]}
                                                            <div className={`${newStyle.popup_files_item_icon}`}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width={15} height={15}><path d="M378.4 71.4c8.5-10.1 7.2-25.3-2.9-33.8s-25.3-7.2-33.8 2.9L192 218.7 42.4 40.6C33.9 30.4 18.7 29.1 8.6 37.6S-2.9 61.3 5.6 71.4L160.7 256 5.6 440.6c-8.5 10.2-7.2 25.3 2.9 33.8s25.3 7.2 33.8-2.9L192 293.3 341.6 471.4c8.5 10.1 23.7 11.5 33.8 2.9s11.5-23.7 2.9-33.8L223.3 256l155-184.6z"/></svg>
                                                            </div>
                                                         </div>
                                            })
                                        }
                                    </div>
                                    <div className={`${newStyle.popup_container_content_body_submit}`} onClick={() => {submitHandle()}}>
                                        ثبت
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-md-9" >
                                <div className={`mt-3 px-0 ${Dstyles.container}`}>
                                    <DashboardHeader onClick={() => setModalShow(true)} />

                                    <div className="py-2">
                                                <div className="container-fluid">
                                                    <div
                                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                                        dir="rtl"
                                                    >
                                                        <div className={`w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2 ${newStyle.pointer}`} onClick={goBackToDashboard}>
                                                            <div className='d-flex align-items-center justify-content-center'>
                                                                <a href='#' onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                                                <div className={Dstyles.text1}>
                                                                    مدیریت لندینگ
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={`${newStyle.main_container}`}>
                                                                <div className={`${newStyle.main_categories_container}`}>
                                                                    {
                                                                        landings.map((landing) => {
                                                                            return <div className={`${newStyle.category_button_nohover} ${newStyle.category_button_bottom}`}>
                                                                            <div className={`${newStyle.category_button_content}`}>{landing.title}</div>
                                                                            <div className={`${newStyle.category_button_content_container}`}>
                                                                                <div style={{marginLeft: "20px"}}>
                                                                                    تعداد فایل: {landing.files}
                                                                                </div>
                                                                                <div className={`${newStyle.category_button_content_button}`} onClick={() => {history.push("/لندینگ/" + landing.link)}}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style={{width: "15px", height: "15px"}}><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"/></svg>
                                                                                </div>
                                                                                <div className={`${newStyle.category_button_content_button}`} onClick={() => {startEditing(landing.id)}}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{width: "15px", height: "15px"}}><path d="M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4z"/></svg>
                                                                                </div>
                                                                                <div className={`${newStyle.category_button_content_button}`} onClick={() => {deleteLanding(landing.id)}}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{width: "15px", height: "15px"}}><path d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"/></svg>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        })
                                                                    }
                                                                    <div className={`${newStyle.categories_back_button}`} onClick={() => {setIsModelOpen(true); setIsEditing(0)}}>
                                                                        <div className={`${newStyle.categories_back_button_content_text}`}>
                                                                            افزودن لندینگ جدید
                                                                        </div>
                                                                        <div className={`${newStyle.categories_back_button_content_svg}`}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{width: "20px", width: "20px"}}><path d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"/></svg></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    </div>
                                                </div>
                                            </div>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                {/* sideMenu starts */}
                                <DashboardSideMenu landingManagement/>
                                {/* sideMenu ends */}
                            </div>
                        </div>
                    </div>
                )}

        </>
    );
};

export default React.memo(LandingManagement);